import { render, staticRenderFns } from "./PacientesDetalleGaleriaTratamiento.vue?vue&type=template&id=0f745184"
import script from "./PacientesDetalleGaleriaTratamiento.vue?vue&type=script&lang=js"
export * from "./PacientesDetalleGaleriaTratamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports